import { client } from "../client/client";

// utils/formatDate.js
export const formatDateToYMD = (date) => {
  if (!date) return null;

  const d = new Date(date);
  if (isNaN(d)) return null; // invalid date

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const exportLoans = async (
  format,
  fromDate,
  toDate,
  search,
  status,
  minLoanAmount,
  maxLoanAmount,
  product,
  loanOfficer,
) => {
  try {
    const params = new URLSearchParams();
    if (format != null) params.append("format", format);
    if (fromDate) params.append("from", formatDateToYMD(fromDate));
    if (toDate) params.append("to", formatDateToYMD(toDate));
    if (search) params.append("q", search);
    if (status) params.append("status", status);
    if (status) params.append("status", status);
    if (loanOfficer) params.append("loanOfficerId", loanOfficer);
    if (product) params.append("productName", product);
    if (minLoanAmount) params.append("minBalance", minLoanAmount);
    if (maxLoanAmount) params.append("maxBalance", maxLoanAmount);

    const response = await client.get(`/loans/export?${params.toString()}`, {
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const exportAllLoanTransactions = async (
  loanId,
  format,
  fromDate,
  toDate,
  search,
  status,
  method,
  type,
) => {
  try {
    const params = new URLSearchParams();

    if (format != null) params.append("format", format);
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);
    if (search) params.append("q", search);
    if (status) params.append("status", status);
    if (method) params.append("method", method);
    if (type) params.append("type", type);

    const response = await client.get(
      `/loans/${loanId}/transactions/export?${params.toString()}`,
      {
        responseType: "blob",
      },
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const exportAllSelectedLoanTransactions = async (
  loanId,
  format,
  selectedLoanTransactions,
) => {
  try {
    const response = await client.post(
      `/loans/${loanId}/transactions/export/selected`,
      { format: format, ids: selectedLoanTransactions },
      {
        responseType: "blob",
      },
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const exportAllTransactions = async (
  format,
  fromDate,
  toDate,
  search,
  status,
  method,
  type,
) => {
  try {
    const params = new URLSearchParams();

    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);
    if (search) params.append("q", search);
    if (status) params.append("status", status);
    if (method) params.append("method", method);
    if (type) params.append("type", type);

    const response = await client.get(
      `/transaction/export/${format}?${params.toString()}`,
      {
        responseType: "blob",
      },
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const exportAllSelectedTransactions = async (
  format,
  selectedLoanTransactions,
) => {
  try {
    const response = await client.post(
      `/transaction/export/selected/${format}`,
      { ids: selectedLoanTransactions },
      {
        responseType: "blob",
      },
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const exportAllSelectedLoans = async (format, selectedLoans) => {
  try {
    const response = await client.post(
      `/loans/export-selected`,
      { format: format, ids: selectedLoans },
      {
        responseType: "blob",
      },
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const exportAllBorrowers = async (format, fromDate, toDate, status) => {
  try {
    const params = new URLSearchParams();
    if (format != null) params.append("format", format);
    if (fromDate) params.append("fromDate", formatDateToYMD(fromDate));
    if (toDate) params.append("toDate", formatDateToYMD(toDate));
    if (status) params.append("status", status);

    const response = await client.get(`/customer/export?${params.toString()}`, {
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const exportAllSelectedBorrowers = async (borrowers, format) => {
  try {
    const response = await client.post(
      `/customer/export?format=${format}`,
      {
        selectedCustomers: borrowers,
      },
      {
        responseType: "blob",
      },
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const exportLoanApplications = async (
  format,
  fromDate,
  toDate,
  search,
  status,
  minLoanAmount,
  maxLoanAmount,
  product,
  loanOfficer,
) => {
  try {
    const params = new URLSearchParams();
    if (format != null) params.append("format", format);
    if (fromDate) params.append("from", formatDateToYMD(fromDate));
    if (toDate) params.append("to", formatDateToYMD(toDate));
    if (search) params.append("q", search);
    if (status) params.append("status", status);
    if (status) params.append("status", status);
    if (loanOfficer) params.append("loanOfficerId", loanOfficer);
    if (product) params.append("productName", product);
    if (minLoanAmount) params.append("minBalance", minLoanAmount);
    if (maxLoanAmount) params.append("maxBalance", maxLoanAmount);

    const response = await client.get(
      `/loan-applications/export?${params.toString()}`,
      {
        responseType: "blob",
      },
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const exportAllSelectedLoanApplications = async (
  format,
  selectedLoanApplications,
) => {
  try {
    const response = await client.post(
      `/loan-applications/export-selected`,
      {
        format: format,
        ids: selectedLoanApplications,
      },
      {
        responseType: "blob",
      },
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
